import { render, staticRenderFns } from "./AvisoEstudiantes.vue?vue&type=template&id=2e6b01d3&scoped=true&"
import script from "./AvisoEstudiantes.vue?vue&type=script&lang=js&"
export * from "./AvisoEstudiantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b01d3",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/AvisoEstudiantes.vue
// module id = 587
// module chunks = 0